import includes from 'lodash/includes'
import React from 'react'
import { GetStartedButton } from './get-started-button'
import { useLocation } from 'react-router-dom'
import { Link } from './Link'

export const NavBar = () => {
  const navBarRef = React.useRef(null)
  const dropdownRef = React.useRef(null)
  const navToggleRef = React.useRef(null)

  const location = useLocation()

  const isActive = (currentPath: string) => {
    const path = location.pathname
    if (currentPath === 'home' && path === '/') return 'active'

    return includes(path, currentPath) ? 'active' : ''
  }

  // Exact-match variant for prefix-colliding routes: '/hauler' substring-matches
  // '/hauler-next' under isActive, so both use this to stay mutually exclusive.
  const isActiveExact = (currentPath: string) => {
    const path = location.pathname
    return path === currentPath || path.startsWith(`${currentPath}/`) ? 'active' : ''
  }

  const onMobileNavDropdownClick = (e) => {
    e.preventDefault()
    if (navBarRef.current.classList.contains('navbar-mobile')) {
      e.preventDefault()
      dropdownRef.current.classList.toggle('dropdown-active')
    }
  }

  const onMobileNavToggleClick = () => {
    navBarRef.current.classList.toggle('navbar-mobile')
    navToggleRef.current.classList.toggle('bi-list')
    navToggleRef.current.classList.toggle('bi-x')
  }

  return (
    <nav id="navbar" ref={navBarRef} className="navbar">
      <ul>
        <li>
          <a href="tel:8556455776">Call toll-free 1.855.MILKPRO (855.645.5776)</a>
        </li>

        <li>
          <Link reloadDocument to="/" className={isActive('home')}>
            Home
          </Link>
        </li>
        <li className="dropdown">
          <a
            onClick={onMobileNavDropdownClick}
            href="/"
            className={isActive('/payroll') || isActive('/lab') || isActive('/hauler') || isActive('/hauler-next') || isActive('/principal')}
          >
            <span>Our Apps</span> <i className="bi bi-chevron-down" />
          </a>
          <ul ref={dropdownRef}>
            <li>
              <Link reloadDocument className={isActive('/payroll')} to="/payroll">
                Payroll
              </Link>
            </li>
            <li>
              <Link reloadDocument className={isActiveExact('/hauler')} to="/hauler">
                Hauler
              </Link>
            </li>
            <li>
              <Link reloadDocument className={isActiveExact('/hauler-next')} to="/hauler-next">
                Hauler Next
              </Link>
            </li>
            <li>
              <Link reloadDocument className={isActive('/lab')} to="/lab">
                Lab
              </Link>
            </li>

            <li>
              <Link className={isActive('/principal')} to="/principal">
                Principal
              </Link>
            </li>
          </ul>
        </li>
        <li>
          <Link to="/docs" className={isActive('/docs')} reloadDocument>
            Docs
          </Link>
        </li>

        <li>
          <GetStartedButton />
        </li>
      </ul>
      <i onClick={onMobileNavToggleClick} ref={navToggleRef} className="bi bi-list mobile-nav-toggle" />
    </nav>
  )
}
